import * as React from "react";
import { sizeStyles } from "../constants";
import type { HierarchyNode, NodeState } from "../types";
import { NodeItem } from "./NodeItem";

interface NodeListProps<T extends HierarchyNode> {
  items: T[];
  showConnector?: boolean;
  scrollContainerRef?: React.RefObject<HTMLDivElement | null> | null;
  showBullets: boolean;
  size: "xs" | "sm" | "md";
  renderNode?: (node: T, state: NodeState) => React.ReactNode;
}

export function NodeList<T extends HierarchyNode>({
  items,
  showConnector = false,
  scrollContainerRef,
  showBullets,
  size,
  renderNode,
}: NodeListProps<T>) {
  return (
    <div className="relative" ref={showConnector && scrollContainerRef ? scrollContainerRef : undefined}>
      {/* Vertical connector line running through all bullets */}
      {showBullets && items.length > 0 && showConnector && (
        <div
          className="absolute w-px bg-text-caption z-10 pointer-events-none"
          style={{
            left: `${sizeStyles[size].spacing.x + sizeStyles[size].bullet / 2}px`,
            top: `${sizeStyles[size].spacing.y + sizeStyles[size].bullet / 2}px`,
            bottom: `${sizeStyles[size].spacing.y + sizeStyles[size].bullet / 2}px`,
          }}
          aria-hidden="true"
        />
      )}
      {items.map((node) => (
        <NodeItem key={node.id} node={node as T} renderNode={renderNode} />
      ))}
    </div>
  );
}
